var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFooterInstagram = function SvgFooterInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666664",
    clipPath: "url(#footer-instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.648A6.359 6.359 0 0 0 5.648 12 6.359 6.359 0 0 0 12 18.352 6.359 6.359 0 0 0 18.352 12 6.359 6.359 0 0 0 12 5.648Zm0 11.297A4.951 4.951 0 0 1 7.055 12 4.951 4.951 0 0 1 12 7.055 4.95 4.95 0 0 1 16.945 12 4.95 4.95 0 0 1 12 16.945Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.582 2.418A8.175 8.175 0 0 0 15.766 0H8.234a8.175 8.175 0 0 0-5.816 2.418A8.175 8.175 0 0 0 0 8.234v7.532c0 2.19.859 4.256 2.418 5.816A8.175 8.175 0 0 0 8.234 24h7.532a8.175 8.175 0 0 0 5.816-2.418A8.175 8.175 0 0 0 24 15.766V8.234a8.175 8.175 0 0 0-2.418-5.816Zm1.012 13.348a6.836 6.836 0 0 1-6.828 6.828H8.234a6.836 6.836 0 0 1-6.828-6.828V8.234a6.836 6.836 0 0 1 6.828-6.828h7.532a6.836 6.836 0 0 1 6.828 6.828v7.532Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.54 4.756a.708.708 0 0 0-.498.206.708.708 0 0 0-.206.497c0 .185.075.367.206.497a.707.707 0 0 0 1.2-.497.708.708 0 0 0-.702-.703Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "footer-instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFooterInstagram;